module.exports = __webpack_public_path__ + "img/afternoon_study2.7177fe80.png";